

exports.__esModule = true;
exports.submitButtonTextKey = exports.upopConfirmButtonTextKey = exports.pageTitleProps = exports.pageTitle = undefined;

var _constants = require('../constants/constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var pageTitle = function pageTitle(models, mode, fiMode) {
    if (models.checkoutInputData.isEbayTxn()) {
        // prox signup flow title
        return 'signupAccountCreation.heading';
    } else if (fiMode === 'bank') {
        return 'largeScreenPayment.bankTitle';
    } else if (models.checkoutCart.isWalletTokenization()) {
        return 'common.createPayPalSubTitleSignup';
    } else if (mode === 'signup') {
        return 'largeScreenPayment.signupTitle';
    } else {
        return 'largeScreenPayment.title';
    }
};

var pageTitleProps = function pageTitleProps(models) {
    if (models.checkoutCart.isWalletTokenization()) {
        return 'signup.androidPayTitleProp';
    } else {
        return 'largeScreenPayment.titleProp';
    }
};

var upopConfirmButtonTextKey = function upopConfirmButtonTextKey(flags) {
    var buttonTextKey = 'confirmUpop.confirmAndContinueToMerch';
    if (flags.wpsFlow) {
        buttonTextKey = 'confirmUpop.confirmAndContinue';
    } else if (flags.commit) {
        buttonTextKey = 'confirmUpop.confirmAndPay';
    }
    return buttonTextKey;
};

var submitButtonTextKey = function submitButtonTextKey(flags, showNewSignupComplianceExp) {
    var getCommitOrContinueText = function getCommitOrContinueText(mode) {
        return _constants2['default'].submitButtonTextKeyMap[mode][showNewSignupComplianceExp ? 'US' : 'ROW'][flags.commit ? 'commit' : 'notCommit'];
    };

    var buttonTextKey = void 0;

    if (flags.show_poma_ui) {
        buttonTextKey = getCommitOrContinueText(flags.poma_flow ? 'pomaSignup' : 'guest');
    } else {
        buttonTextKey = getCommitOrContinueText(flags.mode === 'signup' ? 'signup' : 'guest');
    }

    return buttonTextKey;
};

exports.pageTitle = pageTitle;
exports.pageTitleProps = pageTitleProps;
exports.upopConfirmButtonTextKey = upopConfirmButtonTextKey;
exports.submitButtonTextKey = submitButtonTextKey;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/lib/pageProps.js
// module id = ./components/xo-guest-components/src/guest/lib/pageProps.js
// module chunks = 1